import Vue from 'vue'
import VueRouter from 'vue-router'
import SignatureMain from '@/components/SignatureMain'
import CertificateMain from '@/components/CertificateMain'
import HelpPage from '@/components/HelpPage'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/signature'
  },
  {
    path: '/signature',
    name: 'Signature',
    component: SignatureMain
  },
  {
    path: '/certificate',
    name: 'Certificate',
    component: CertificateMain
  },
  {
    path: '/help',
    name: 'Help',
    component: HelpPage
  }
]

const router = () => {
  return new VueRouter({ routes })
}

export default router
